import { MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { IconButton } from '~/components/atoms/IconButton';

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <IconButton
      label={isDark ? 'Light mode' : 'Dark mode'}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </IconButton>
  );
}
